import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-brand-mark',
  template: `
    <img *ngIf="theme.brand.logo"
         [src]="theme.brand.logo"
         [alt]="theme.brand.name"
         [attr.height]="height"
         [style.max-width]="maxWidth">
    <span *ngIf="!theme.brand.logo" class="brand-wordmark">{{ theme.brand.name }}</span>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; }
    img { display: block; width: auto; height: auto; }
    .brand-wordmark {
      font-family: var(--font-ui, Inter, sans-serif);
      font-weight: 600;
      letter-spacing: -0.03em;
      color: var(--text-primary, #09090b);
      font-size: 18px;
      line-height: 1.1;
    }
  `]
})
export class BrandMarkComponent {
  @Input() height = '40';
  @Input() maxWidth = '100%';

  constructor(public theme: ThemeService) {}
}
